import { createAction, props } from '@ngrx/store';

export class CronActions {
    static daily = createAction('[Cron] Daily', props<{ ts: string }>());
    static minutely = createAction('[Cron] Minutely', props<{ ts: string }>());
    static noOp = createAction('[Cron] NoOp')
}